import { GlobalUspItemModel } from 'autogen/swagger/all';
import PageAction from 'components/shared/Routing/PageAction';
import format from 'helpers/translations';
import styled, { css } from 'styled-components';

const uspStyling = css`
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &:link,
    &:visited,
    &:hover,
    &:active {
        text-decoration: none;
    }
`;

const Text = styled.div`
    ${uspStyling}
`;

const StyledLink = styled(PageAction)`
    ${uspStyling}
`;

export default function USP({ link, text }: GlobalUspItemModel) {
    return link ? (
        <StyledLink {...link} action={link.pageAction}>
            {format(text)}
        </StyledLink>
    ) : (
        <Text>{format(text)}</Text>
    );
}
